<div class="app-wrapper" [class]="modeClass()" [style.--bg-url]="'url(' + displayedBackground() + ')'">
  <app-debug-info [debugVisible]="false"></app-debug-info>
  <router-outlet></router-outlet>
  <app-loading-panel></app-loading-panel>
  <!-- add a div for dxPopup wrapper to show the loadingPanel in front -->
  <div id="containerPopup" style="position: relative"></div>
</div>
<app-global-notification></app-global-notification>
